import { createContext, useContext } from "react";
import { LanguageType, VersionType } from "./constants";

export type GlobalContent = {
  query: string;
  setQuery: (query: string) => void;
  handleChange: (e: any) => void;
  handleSubmit: (versions: VersionType[], query: string) => void;
  openSettings: (page?: number) => void;
  versions: VersionType[];
  setVersions: (versions: VersionType[]) => void;
  colorMode: string;
  toggleColorMode: () => void;
  textAreaFontSize: number;
  setTextAreaFontSize: (fontSize: number) => void;
  textAreaLineHeight: number;
  setTextAreaLineHeight: (lineHeight: number) => void;
  copyWithVerse: boolean;
  setCopyWithVerse: (copyWithVerse: boolean) => void;
  viewMode: "combined" | "verses";
  setViewMode: (viewMode: "combined" | "verses") => void;
  isEnglish: boolean;
  language: LanguageType;
  setLanguage: (language: LanguageType) => void;
};

export const AppContext = createContext<GlobalContent>({
  query: "",
  setQuery: () => void 0,
  handleChange: () => void 0,
  handleSubmit: () => void 0,
  openSettings: () => void 0,
  versions: [VersionType.ESV],
  setVersions: () => void 0,
  colorMode: "light",
  toggleColorMode: () => void 0,
  textAreaFontSize: 16,
  setTextAreaFontSize: () => void 0,
  textAreaLineHeight: 1.5,
  setTextAreaLineHeight: () => void 0,
  copyWithVerse: false,
  setCopyWithVerse: () => void 0,
  viewMode: "combined",
  setViewMode: () => void 0,
  isEnglish: true,
  language: "EN",
  setLanguage: () => void 0,
});

export const useAppContext = () => useContext(AppContext);
